module.exports = __webpack_public_path__ + "static/media/healthy.149788b1.jpg";